import { useContext, useEffect, useMemo, useRef, useState } from "react"
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext"
import { dateConvert } from "../../../utils/Helper";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const useAssignAsset = ({ onClose, editData, gridData, dropdownOpts, handleAssetDetails, filterValues }) => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [fieldValues, setFieldValues] = useState({ assign_to: {}, other_assets: [], disable_assigned: [], assign_date: _.isEmpty(editData?.is_currently_assigned) ? new Date() : null, remark: "", media: [], asset_allocation_form: false });
    const [options, setOptions] = useState({ assign_to: [], assets_assignee: [] });
    const [loader, setLoader] = useState(false);
    const allocationFormRef = useRef(null);

    useEffect(() => {
        callautopopulate("all_users", "assets_assignee")?.then((res) => {
            setOptions((prev) => ({ ...prev, assign_to: _.sortBy(res?.all_users, "user_display_name"), assets_assignee: res?.assets_assignee }))
        })
        // handle addition assign assets options
        const assets = _.sortBy(_.filter(dropdownOpts?.assets_details, item => !item?.is_asset_assign && item?.asset_id !== editData?.asset_id && _.pluck(filterValues?.locations, "location")?.includes(item?.location_name)), "asset_unique_id");
        let all = {};
        dropdownOpts?.assets_details?.forEach(item => all[item?.asset_id] = item?.asset_unique_id);
        setOptions((prev) => ({ ...prev, assets_details: assets, unassigned_assets_details: assets, all_assets: all }));
    }, [dropdownOpts])

    useEffect(() => {
        if (!_.isEmpty(editData)) {

            let alsoAssigned = [];
            // default select data from edit data
            if (!_.isEmpty(editData?.is_currently_assigned)) {
                alsoAssigned = _.uniq(editData?.child_assets?.map(item => item?.child_asset_ids?.split(","))?.flatMap(item => item))?.map(item => parseInt(item));
                setFieldValues((prev) => ({
                    ...prev,
                    assign_to: _.findWhere(options?.assign_to, { user_code: editData?.is_currently_assigned?.user_code }) || [],
                    remark: editData?.is_currently_assigned?.assigned_remark || "",
                    media: [],
                    assign_date: new Date(editData?.is_currently_assigned?.assigned_date) || null,
                    other_assets: alsoAssigned,
                    disable_assigned: alsoAssigned,
                }))
                setOptions((prev) => ({ ...prev, assets_details: [...prev?.unassigned_assets_details, ...alsoAssigned?.map(item => { return _.findWhere(dropdownOpts?.assets_details, { asset_id: parseInt(item) }) })] }))
            }

            // set images
            let parentMedia = [];
            let childMedia = {};
            if (!_.isEmpty(editData?.is_currently_assigned)) {
                _.filter(editData?.trans_media, item => item?.details?.asset_trans_media_type?.trim()?.toLowerCase() === "a")?.forEach((item) => {
                    const assignedTransIds = _.uniq(editData?.child_assets?.map(item => item?.child_trans_ids?.split(","))?.flatMap(item => item))?.map(item => parseInt(item));
                    if (item?.details?.asset_id === editData?.asset_id && item?.details?.asset_tran_id === editData?.is_currently_assigned?.asset_tran_id) {
                        parentMedia.push(item?.media_obj);
                        setFieldValues((prev) => ({ ...prev, media: _.uniq(parentMedia, "base64") }));
                    } else if(assignedTransIds?.includes(item?.details?.asset_tran_id)) {
                        if(childMedia[options?.all_assets?.[item?.details?.asset_id]]) {
                            childMedia[options?.all_assets?.[item?.details?.asset_id]].push(item?.media_obj);
                            childMedia[options?.all_assets?.[item?.details?.asset_id]] = _.uniq(childMedia[options?.all_assets?.[item?.details?.asset_id]], "base64");
                        } else {
                            childMedia[options?.all_assets?.[item?.details?.asset_id]] = [item?.media_obj];
                        }
                    }
                })
                setFieldValues((prev) => ({ ...prev, ...childMedia }));
            }
        }
    }, [editData, gridData, options.assign_to])

    const handleAssign = async () => {
        try {
            if (_.isEmpty(fieldValues?.assign_to)) {
                showInfo("Info", "Please select a user to assign the asset");
                return;
            } else if (!fieldValues?.remark) {
                showInfo("Info", "Please enter assign remark");
                return;
            }

            if (!allocationFormRef.current) {
                console.error("Asset Allocation Form Ref not found");
                return;
            }

            // forming dynamic pdf of asset allocation
            const element = allocationFormRef.current;
            const canvas = await html2canvas(element, {
                scale: 1.5
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("portrait", "pt", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 70, pdfWidth, pdfHeight);
            const base64PDF = pdf.output('datauristring');
            if(!base64PDF) {
                console.error("Asset Allocation Form PDF not formed");
                return;
            }
            // pdf.save("AssetAllocationForm.pdf");

            setLoader(true);
            let mediaTvpArray = [];
            fieldValues?.media?.forEach((item) => {
                const transData = _.filter(editData?.assigned_history, (obj) => obj?.asset_unique_id === editData?.asset_unique_id && obj?.asset_trans_type?.trim()?.toLowerCase() === "a");
                const mediaData = _.filter(editData?.trans_media, (obj) => _.isEqual(obj?.media_obj, item));
                mediaTvpArray.push({
                    "asset_unique_id": editData?.asset_unique_id || "",
                    "media_file_id": mediaData?.[0]?.details?.media_file_id || 0,
                    "asset_tran_id": transData?.[0]?.asset_tran_id || 0,
                    "asset_base64_string": item?.base64 || "",
                    "asset_unique_file_id": ""
                })
            })

            // media tvp array of other assets assigned together
            fieldValues?.other_assets?.forEach((item) => {
                const uniqueId = options?.all_assets?.[item]
                fieldValues?.[uniqueId]?.forEach(media => {
                    const transData = _.filter(editData?.all_history, (obj) => obj?.asset_unique_id === uniqueId && obj?.asset_trans_type?.trim()?.toLowerCase() === "a");
                    const mediaData = _.filter(editData?.trans_media, (obj) => _.isEqual(obj?.media_obj, media));;
                    mediaTvpArray.push({
                        "asset_unique_id": uniqueId || "",
                        "media_file_id": mediaData?.[0]?.details?.media_file_id || 0,
                        "asset_tran_id": transData?.[0]?.asset_tran_id || 0,
                        "asset_base64_string": media?.base64 || "",
                        "asset_unique_file_id": ""
                    })
                })
            })
            const payload = {
                "assets_ids": [editData?.asset_id, ...fieldValues?.other_assets]?.toString() || 0,
                "assigned_remark": fieldValues?.remark || "",
                "assigned_user_code": fieldValues?.assign_to?.user_code,
                "assets_assignee_id": options?.assets_assignee?.[0].assets_assignee_id,
                "assets_assign_media": mediaTvpArray || [],
                "assign_date": dateConvert(fieldValues?.assign_date || new Date(), "iso-string")?.split("T")?.[0],
                "asset_assign_base64_string": base64PDF?.split(",")?.[1],
                "is_mail_send": (!_.isEqual(fieldValues?.disable_assigned, fieldValues?.other_assets))?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTASSETSASSIGN"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                setLoader(false);
                handleAssetDetails()
                onClose();
            }
        } catch (error) {
            console.error("Error assigning asset: ", error);
            showError("error", error?.response?.data?.errorMessage);
            setLoader(false);
        }
    }

    const handleReset = () => {
        setFieldValues({ assign_to: {}, other_assets: [], disable_assigned: [], assign_date: _.isEmpty(editData?.is_currently_assigned) ? new Date() : null, remark: "", media: [], asset_allocation_form: false });
    }

    return useMemo(() => ({
        fieldValues, setFieldValues, options, handleReset, handleAssign, loader, allocationFormRef
    }), [fieldValues, setFieldValues, options, handleReset, handleAssign, loader, allocationFormRef])
}